export const getBankNameFromAccount = ({ account, short = true }) => {
  if (account == null) return '';

  if (short) return account.nickname || account.bank_name;

  return `${account.nickname || account.bank_name || ''} - ${account.last4}`;
};
